module.exports = __webpack_public_path__ + "img/mango-lassi.1621b7e4.jpg";